import { useTheme } from '@mui/material';
const useAccountInformationStyles = () => {
    const theme = useTheme();
    return {
        mainContainerStyles: {
            width: '100%',
            padding: 2,
            borderRadius: 2,
            boxShadow: '0px 12px 24px -4px #919EAB1F,0px 0px 2px 0px #919EAB33'
        },
        headerStyles: {
            width: '100%',
            mb: 1,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        }
    };
};
export default useAccountInformationStyles;
